/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebDeleteFavoriteModel,
  IWebDeleteFavoriteRequest,
  IMappers,
  IWebDeleteFavoriteResponse,
  IWebDeleteFavoriteResponseError,
  TWebDeleteFavoriteResponse,
} from './types';

const defaultConfig: TWebDeleteFavoriteModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/delete-favorite/',
  hostType: 'api',
} as TWebDeleteFavoriteModel;

function createWebDeleteFavoriteModel(parameters: IWebDeleteFavoriteRequest): TWebDeleteFavoriteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebDeleteFavoriteOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IWebDeleteFavoriteRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchWebDeleteFavorite<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebDeleteFavoriteOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TWebDeleteFavoriteResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebDeleteFavoriteModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IWebDeleteFavoriteResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IWebDeleteFavoriteResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TWebDeleteFavoriteResponse;
}

export { defaultConfig, createWebDeleteFavoriteModel, fetchWebDeleteFavorite };
